import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import {
  Backdrop,
  CircularProgress,
  Grid,
  Stack,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import moment from "moment";
import GetReportHistoryList from "hooks/GetReportHistoryList/getReportHistoryList";
import { Download } from "@mui/icons-material";
import FileDownloadOffIcon from "@mui/icons-material/FileDownloadOff";
import DataTable from "comps/Tables/DataTable";
const ReportHistory = () => {
  let { textColor, primary } = colors;
  const [data, setData] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [reportList, setReportList] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [filteredOptions, setFilteredOptions] = useState({});
  const [searchQuery, setSearchQuery] = useState({});
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [isReportSelected, setIsReportSelected] = useState(false);
  const [debouncedSearches, setDebouncedSearches] = useState({});
  const {
    reportHistory,
    setReportHistory,
    reportHistoryMap,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    setEntriesPerPage,
    entriesPerPage,
    setSortOrder,
    setSortBy,
    sortBy,
    sortOrder,
  } = GetReportHistoryList();

  useEffect(() => {
    setData(reportHistory);
  }, [reportHistory]);

  useEffect(() => {
    setPage(pagination.pageIndex);
    setEntriesPerPage(pagination.pageSize);
  }, [pagination]);

  useEffect(() => {
    if (sorting.length === 1) {
      if (sorting[0].desc === false) {
        if (sorting[0].id === "jobId") {
          setSortBy("id");
        } else {
          setSortBy(sorting[0].id);
        }
        setSortOrder("asc");
      } else {
        if (sorting[0].id === "jobId") {
          setSortBy("id");
        } else {
          setSortBy(sorting[0].id);
        }
        setSortOrder("desc");
      }
    } else if (sorting.length === 0) {
      setSortBy("jobId");
      setSortOrder("desc");
    }
  }, [reportHistory, sorting]);

  let columns = [
    {
      accessor: "jobId",
      Header: "Job Id",
      size: 50,
      headerAlign: "center",
      align: "center",
    },
    {
      accessor: "reportName",
      Header: "Report Name",
      size: 50,
      enableSorting: false,
      headerAlign: "left",
      align: "left",
      Cell: ({ row }) => {
        const reportName = row?.original?.reportName;
        const truncatedName =
          reportName?.length > 25
            ? reportName.substring(0, 25) + "..."
            : reportName;
        return (
          <Tooltip title={reportName} placement="bottom-start">
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "statusName",
      Header: "Status Name",
      size: 50,
      enableSorting: false,
      align: "center",
      Cell: ({ row }) => {
        const statusName = row?.original?.statusName;
        const truncatedName =
          statusName?.length > 15
            ? statusName.substring(0, 15) + "..."
            : statusName;
        return (
          <Tooltip title={statusName} placement="bottom-start">
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "startDate",
      Header: "Start Date",
      size: 50,
      align: "center",

      Cell: ({ row }) => {
        return (
          <Tooltip
            title={moment(row?.original?.startDate).format(
              "YYYY-MM-DD, h:mm:ss a"
            )}
          >
            <div>{moment(row?.original?.startDate).format("YYYY-MM-DD")}</div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "endDate",
      Header: "End Date",
      size: 50,
      align: "center",

      Cell: ({ row }) => {
        return (
          <Tooltip
            title={moment(row?.original?.endDate).format(
              "YYYY-MM-DD, h:mm:ss a"
            )}
          >
            <div>{moment(row?.original?.endDate).format("YYYY-MM-DD")}</div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "emailSentStatus",
      Header: "Email Sent",
      size: 50,
      align: "center",
    },

    {
      accessor: "userName",
      Header: "UserName",
      size: 50,
      enableSorting: false,
      align: "center",

      Cell: ({ row }) => {
        const userName = row?.original?.userName;
        const truncatedName =
          userName?.length > 15 ? userName.substring(0, 15) + "..." : userName;
        return (
          <Tooltip title={userName} placement="bottom-start">
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "reasonOfFailure",
      Header: "Reason of Failure",
      size: 50,
      enableSorting: false,
      align: "center",

      Cell: ({ row }) => {
        const reasonOfFailure = row?.original?.reasonOfFailure;
        const truncatedName =
          reasonOfFailure?.length > 15
            ? reasonOfFailure.substring(0, 15) + "..."
            : reasonOfFailure;
        return (
          <Tooltip
            title={reasonOfFailure || "No reason provided"}
            placement="top"
          >
            <div>{truncatedName || "NA"}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "filePathUrl",
      Header: "Download",
      size: 50,
      enableSorting: false,
      align: "center",

      Cell: ({ row }) => {
        const fileUrl = row?.original?.filePathUrl;

        return fileUrl ? (
          <a href={fileUrl} download="">
            <Download sx={{ color: "#59A65E" }} />
          </a>
        ) : (
          <FileDownloadOffIcon
            sx={{ color: "#59A65E", cursor: "not-allowed" }}
          />
        );
      },
    },
  ];

  // const table = useMaterialReactTable({
  //   columns,
  //   data,
  //   enableStickyHeader: true,
  //   manualPagination: true,
  //   rowCount: totalLength,
  //   onPaginationChange: setPagination,
  //   state: { density: "compact", pagination, sorting },
  //   enableColumnPinning: true,
  //   enableGlobalFilter: true,
  //   enableDensityToggle: false,
  //   manualSorting: true,
  //   muiPaginationProps: {
  //     rowsPerPageOptions: [25, 50, 100],
  //   },
  //   muiTableBodyRowProps: ({ row }) => ({
  //     style: { textDecoration: "none", color: "inherit" },
  //   }),
  //   onSortingChange: setSorting,
  //   muiTableContainerProps: {
  //     sx: {
  //       maxHeight: "calc(100vh - 280px)",
  //       overflowY: "auto",
  //     },
  //   },
  //   muiTablePaperProps: {
  //     elevation: 0,
  //     sx: {
  //       width: "100%",
  //       borderRadius: "0",
  //       backgroundColor: "#fff !important",
  //       zIndex: 500,
  //     },
  //   },
  //   renderEmptyRowsFallback: () => (
  //     <Stack
  //       display="flex"
  //       alignItems="center"
  //       justifyContent="center"
  //       fontSize="14px"
  //       p={5}
  //     >
  //       No records to display
  //     </Stack>
  //   ),
  // });
  return (
    <MDBox>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        pb={1}
      >
        {/* <MDTypography fontSize="25px" >
          Reports History List
        </MDTypography> */}
        <Grid container spacing={1} pb={1} mb={1}
          sx={{
            // flexDirection: { xs: "column", md: "row" },
            // alignItems: { xs: "flex-end", md: "center" },
            borderBottom: `2px solid ${primary.main}`,
          }}
        >
          <Grid
            px={0}
            item
            xs={2}
            md={2}
            display="flex"
            alignItems={"center"}
            flexDirection="row"
            sx={{
              // flexDirection: { xs: "column", md: "row" },
              // alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >
            <MDTypography fontSize="22px" color="black" >
              Reports History List
            </MDTypography>
          </Grid>
          <Grid
            px={1}
            item
            xs={10}
            md={10}
            display="flex"
            justifyContent="flex-end"
            flexDirection="row"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >

          </Grid>
        </Grid>
        <MDBox display="flex" justifyContent="center">
          <MDBox py={1} pb={0} mt={1} pl={0} mr={1} borderRadius="5px" bgColor="white" width="100%">
            <DataTable
              table={{ columns, rows: data }}
              isSorted
              noEndBorder
              entriesPerPage={entriesPerPage}
              canSearch={false}
              tablePage={page}
              setTablePage={setPage}
              setEntriesPerPage={setEntriesPerPage}
              totalLength={totalLength}
              pagination={true}
              setSortOrder={setSortOrder}
              setSortBy={setSortBy}
              rowWidth={"40px"}
              sortBy={sortBy}
              sortOrder={sortOrder}
              setIsLoading={setIsLoading}
              tableMaxHeight={"calc(100vh - 145px)"}
              tableMinHeight={"calc(100vh - 145px)"}
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default ReportHistory;
